import { ColDef } from '@ag-grid-enterprise/all-modules'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import i18n from '@/lang/i18n'
import { ConfigurationImmediateShelfPriorityAssignmentResponse } from '@/modules/configurationModule/detail/automation/grossing-shelf/immediate-shelf-priority/services/configuration-immediate-shelf-priority-assignment/configuration-immediate-shelf-priority-assignment.dto'
import { configurationImmediateShelfPriorityAssignmentService } from '@/modules/configurationModule/detail/automation/grossing-shelf/immediate-shelf-priority/services/configuration-immediate-shelf-priority-assignment/configuration-immediate-shelf-priority-assignment.service'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { store } from '@/store/store'

export const columnsDefAutomationGrossingShelfImmediateShelfPriorityGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.immediateShelfPriority'),
            field: 'priority.name',
            minWidth: 400,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        }
    ]

export interface ConfigurationAutomationGrossingShelfImmediateShelfPriorityGridState extends CrudModelPaginatorLaboratory<ConfigurationImmediateShelfPriorityAssignmentResponse> {
    service: typeof configurationImmediateShelfPriorityAssignmentService
    laboratoryId: number
}
export const initialConfigurationAutomationGrossingShelfImmediateShelfPriorityGridState =
    (): ConfigurationAutomationGrossingShelfImmediateShelfPriorityGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.automation.grossingShelf.immediateShelfPriority',
        columnsDef: columnsDefAutomationGrossingShelfImmediateShelfPriorityGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationImmediateShelfPriorityAssignmentService, store.getters.labId),
        service: configurationImmediateShelfPriorityAssignmentService,
        laboratoryId: store.getters.labId
    })
